// extracted by mini-css-extract-plugin
export default {"dummmy":"pDUKQJR3D5bZELvd_cCk","ship":"j2xgNoQqcQKgklJlCp53","shipActive":"YczRi5VOT6eW0hXzIJt6","shipOrder":"RPaIr_tx8wFfZ0ca8tSu","shipIcon":"BWKEuRsmGXvi58gOV7cr"};